import { render } from "./section_scheduler.vue?vue&type=template&id=1b0c583c"
import script from "./section_scheduler.vue?vue&type=script&lang=js"
export * from "./section_scheduler.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/miqrositio/miqrositio_app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__